var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransferTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 34,
    rx: 17,
    fill: "#0040BF",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2849_37516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.464 20.8791C8.798 20.2141 9.224 19.0951 10.126 19.0071L10.241 19.0011H26C26.2549 19.0014 26.5 19.099 26.6854 19.2739C26.8707 19.4489 26.9822 19.688 26.9972 19.9425C27.0121 20.1969 26.9293 20.4475 26.7657 20.6429C26.6021 20.8384 26.3701 20.964 26.117 20.9941L26 21.0011H12.414L14.707 23.2941C14.8863 23.474 14.9905 23.7155 14.9982 23.9695C15.006 24.2234 14.9168 24.4708 14.7488 24.6614C14.5807 24.8519 14.3464 24.9714 14.0935 24.9955C13.8406 25.0196 13.588 24.9465 13.387 24.7911L13.293 24.7081L9.463 20.8781L9.464 20.8791ZM9 14.0011C9.00003 13.7562 9.08996 13.5198 9.25272 13.3367C9.41547 13.1537 9.63975 13.0367 9.883 13.0081L10 13.0011H23.586L21.293 10.7081C21.1137 10.5281 21.0095 10.2867 21.0018 10.0327C20.994 9.77876 21.0832 9.53138 21.2512 9.34081C21.4193 9.15025 21.6536 9.03079 21.9065 9.00669C22.1594 8.9826 22.412 9.05568 22.613 9.21109L22.707 9.29409L26.537 13.1241C27.202 13.7881 26.776 14.9071 25.874 14.9951L25.759 15.0011H10C9.73478 15.0011 9.48043 14.8957 9.29289 14.7082C9.10536 14.5207 9 14.2663 9 14.0011Z",
    fill: "#0040BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2849_37516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0 -1 1 0 6 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferTable);
export default __webpack_public_path__ + "static/media/TransferTable.04fde5d073a4afe81934c2f2ff820de0.svg";
export { ForwardRef as ReactComponent };